import styled from 'styled-components';

import type { StandardPrices } from '@front/customer/src/types/prices';
import { getFormattedPromotion } from '@front/customer/src/utils/cleaning';

import { translate } from '@front/i18n';

import Separator from '@front/web-ui/src/components/separator/separator';

import { calculationLineStyle } from '../../../../common/common';
import Reduction from '../common/reduction';

const t = translate('basket');

const PromotionLine = styled(Reduction)`
  ${calculationLineStyle}
`;

type MultipleReductionsProps = {
  hasDuration: boolean;
  prices?: StandardPrices;
};

const MultipleReductions = ({ hasDuration, prices }: MultipleReductionsProps) => {
  const hasPromo = !!prices?.promotion;

  return (
    <>
      {hasPromo && (
        <>
          <Separator />
          <PromotionLine title={t('.promo_code')} reduction={getFormattedPromotion(hasDuration, prices?.promotion)} />
        </>
      )}
    </>
  );
};

export default MultipleReductions;
